import { render, staticRenderFns } from "./OverlayBasic.vue?vue&type=template&id=c0cca702&"
import script from "./OverlayBasic.vue?vue&type=script&lang=js&"
export * from "./OverlayBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports